<template>
  <div class="video__wrap">
    <div class="video__container">
      <img :src="i_src" alt="" v-if="videoShow && i_src && i_src != ''" class="cover_img">
      <video :class="['video__element','video__fit', !videoShow ? 'videoOpacity' : '']" ref="video__element" :src="v_src" :poster="i_src" preload="auto"
        :loop="isLoop == 'true'? true : false" :autoplay="isAuto == 'true'? true : false" :muted="isMuted" :controls="showControls" controlslist="nodownload" disablePictureInPicture
        playsinline="true"
        webkit-playsinline="true"
        x5-playsinline="true"
        x5-video-orientation="landscape"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
      >
      </video>
    </div>
    <template v-if="!showControls && vStatus == 0">
      <button class="play__btn" @click="toPlay"></button>
    </template>
  </div>
</template>

<script>
import utils from "@/utils";

export default {
  name: 'VideoWrap',
  props: {
    vSrc: { type: String, required: true },
    vSrc_m: { type: String, required: false },
    iSrc: { type: String, required: false },
    iSrc_m: { type: String, required: false },
    isLoop: { type: null, default: false, required: false },
    isAuto: { type: null, default: false, required: false },
    isMuted: { type: Boolean, default: true, required: false },
    showControls: { type: Boolean, default: false, required: false }
  },
  data() {
    return {
      vStatus: 0, // 1: 播放, 0: 停止
      videoShow: true
    };
  },
  mounted() {
    let vElement = this.$refs?.video__element;
    if (vElement) {
      // vElement.setAttribute("preload", "auto");
      // this.isAuto && vElement.setAttribute("autoplay", true) && (vElement.autoplay = true);
      // this.isMuted && vElement.setAttribute("muted", true) && (vElement.muted = true);
      // this.isLoop && vElement.setAttribute("loop", true) && (vElement.loop = true);
      // this.showControls && vElement.setAttribute("controls", true) && (vElement.controls = true);
      vElement.addEventListener("play", this.vPlay);
      vElement.addEventListener("ended", this.vEnded);
      // vElement.addEventListener("canplay", this.vTimeupdate);
      this.isAuto && this.toPlay();
    }
  },
  computed: {
    isWX() {
      return utils.isWXBrowser();
    },
    isH5() {
      return utils.isMobile() || this.isWX;
    },
    v_src() {
      if (this.isH5 && this.vSrc_m) {
        return this.vSrc_m;
      }
      return this.vSrc;
    },
    i_src() {
      if (this.isH5 && this.iSrc_m && !/1.jpg$/.test(this.iSrc_m)) {
        return this.iSrc_m;
      } else if (this.iSrc && !/1.jpg$/i.test(this.iSrc)) {
        return this.iSrc;
      }
      return ''
    }
  },
  methods: {
    toPlay() {
      if (this.$refs?.video__element?.play) {
        this.$refs.video__element.play();
        this.videoShow = false
      }
    },
    vPlay() {
      this.vStatus = 1;
    },
    vEnded() {
      this.vStatus = 0;
    },
    // vTimeupdate() {
    //   if(this.videoShow) this.videoShow = false
    // },
    // onImgLoaded() {
    //   this.videoShow = false
    // }
  }
}
</script>

<style lang="scss" scoped>
  .video__wrap {
    box-sizing: border-box; width: 100%; height: 100%; position: relative;
    .video__container { width: 100%; height: 100%; position: relative;overflow: hidden;}
    .video__element {
      position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%); object-fit: cover; object-position: center; background: #fff;opacity: 0; width: 100%; height: auto; max-width: 100%;z-index: 0;
      &, &:focus { outline:none; -webkit-tap-highlight-color: transparent; }
      &::-internal-media-controls-download-button { display: none; }
      &::-webkit-media-controls-enclosure { overflow: hidden; }
      &::-webkit-media-controls-panel { width: calc(100% + 30px); }
    }
    .play__btn {
      position: absolute; top: 50%; left: 50%; z-index: 1; transform: translate(-50%,-50%); width: 3.75rem; height: 2.5rem; 
      background-color: #fff; border-radius: 1.375rem; cursor: pointer; transition: all .2s linear;
      &:before {
        content: ""; display: block; width: 0; height: 0;
        border-color: transparent transparent transparent #000;
        border-style: inset inset inset solid;
        border-width: 7px 0 7px 7px;
        position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);
      }
      &:hover {
        background-color: #000;
        &:before { border-left-color: #fff; }
      }
    }
    .cover_img{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
    .videoOpacity{
      opacity: 1;
    }
  }
  @media screen and (min-width: 48em) {
    .video__wrap {
      .video__element { object-fit: cover; }
    }
  }

  @media (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .video__wrap .video__fit {
      object-fit: cover;
    }
  }
</style>